import { useMutation } from '@tanstack/react-query';
import { deleteParkingContract } from '../../api/parking-contract.ts';

export default function useDeleteParkingContract() {
  return useMutation({
    mutationFn: ({ partnerId, id }: { partnerId: string; id: string }) =>
      deleteParkingContract(partnerId, id),
  });
}
